import {Component, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './processing-dialog.component.html',
  styleUrls: ['./processing-dialog.component.css']
})
export class ProcessingDialogComponent {

  @Input()
  public title: string;

  @Input()
  public message: string;

  constructor(protected modal: NgbActiveModal) {
  }

  public close(): void {
    this.modal.close();
  }
}
